import { Box, BoxProps, Icon, Text } from '@chakra-ui/react';
import { ReactComponent as RightArrowIcon } from 'assets_2/icons/right-arrow-icon.svg';
import React from 'react';

interface HowCanWeHelpItemProps extends BoxProps {
  label: string;
}

const HowCanWeHelpItem = ({ label, ...props }: HowCanWeHelpItemProps) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      width="100%"
      padding="8px 16px 9px 19px"
      borderRadius="6px"
      backgroundColor="teal.500"
      minHeight="48px"
      _focus={{
        textDecoration: 'none !important'
      }}
      cursor="pointer"
      {...props}
    >
      <Text
        as="span"
        fontSize="18px"
        lineHeight="24px"
        fontWeight={600}
        color="neutral.0"
        flexGrow={1}
        marginRight="4px"
        fontFamily="ProximaNova"
      >
        {label}
      </Text>

      <Box as="span" flexShrink={0}>
        <Icon
          as={RightArrowIcon}
          width="10px"
          height="12px"
          stroke="neutral.0"
        />
      </Box>
    </Box>
  );
};

export default HowCanWeHelpItem;
